import React, { useEffect, useState } from "react";

//Material UI imports
import {
    CssBaseline,
    Table,
    Paper,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TablePagination,
    Container,
    TableBody,
    IconButton,
    Stack,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel,
    Input,
    InputAdornment,
    FormControl,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import SearchIcon from '@mui/icons-material/Search';

import Alerts from '../components/alerts.jsx'
import LoaderScreen from "../components/loaderScreen.jsx"

//Assets imports
import DeleteIconRoute from '../assets/icons/Delete.png'
import ViewIconRoute from "../assets/icons/View.png";

//CSS imports
import "./../assets/css/fonts.css"

//Components imports
import NavBar from "../components/NavBarComponent/NavBarComponent.jsx"
import { Link, useNavigate } from "react-router-dom";

//Services import
import * as CustomerServices from '../api/customer.jsx'

const theme = createTheme({

    palette: {
        independece: {
            main: '#5C5470',
            contrastText: '#FFFFFF',
        },
    },

    typography: {
        fontFamily: ['Montserrat-Regular'].join(",")
    },

    tableTitle: {
        paddingTop: 30,
        paddingBottom: 30,
    },

    tableHeader: {
        color: "white",
        backgroundColor: "#2A2438",
    },

    avatarActions: {
        backgroundColor: "transparent",
        color: "black",
        height: 30,
        width: 30,
    },

    containerButtonNew: {
        textAlign: "right",
        paddingTop: 100,
        paddingBottom: 30,
    },

    buttonNew: {
        backgroundColor: "#5C5470",
    }
});

const Clients = () => {
    let navigate = useNavigate();

    // Variables to Alerts
    const [openAlert, setOpenAlert] = useState(false);
    const [dataAlert, setDataAlert] = useState({
        message: '',
        type: ''
    })
    const changeStateAlert = () => {
        setOpenAlert(!openAlert)
    }

    // Variables to Confirm
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [dataConfirmation, setDataConfirmation] = useState({
        message: '',
        id: ''
    })
    const changeStateConfirmation = () => {
        setOpenConfirmation(!openConfirmation)
    }

    // Valirable to loader screen
    const [openLoader, setOpenLoader] = useState(false)
    const [textLoader, setTextLoader] = useState('')

    /* Function of table */
    const [dataItems, setDataItems] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    //VARIABLE TO HANDLE SEARCH
    const [searchQuery, setSearchQuery] = useState('')

    const loadItems = async () => {
        const response = await CustomerServices.GetAllCustomers("")
        if (response.success) {
            let data = response.data
            setDataItems(data)
        } else {
            // Falta implementar alert que indique error
            setOpenAlert(true);
            setDataAlert({
                message: response.message,
                type: 'error'
            })
            //console.log(response)
        }

        setOpenLoader(false)
    }

    useEffect(() => {
        document.title = 'ELISA By Inova Evento | Clientes'

        setOpenLoader(true)
        loadItems()
    }, [])

    const openDetails = async (id) => {
        navigate(`/cliente/actualizar/${id}`)
    }

    const deleteUser = async () => {
        const id = dataConfirmation.id
        const response = await CustomerServices.DeleteCustomer(id)

        if (response.success) {
            setOpenAlert(true);
            setDataAlert({
                message: "Se eliminó correctamente al cliente",
                type: 'success'
            })

            setDataConfirmation({
                message: '',
                id: ''
            })
            changeStateConfirmation()

            setOpenLoader(true)
            loadItems()
        } else {
            setOpenAlert(true);
            setDataAlert({
                message: response.message,
                type: 'error'
            })
        }
    }

    const handleSearch = async (value) => {
        //console.log("VALUE: ", value)
        setSearchQuery(value)

        if(value === ''){
            const response = await CustomerServices.GetAllCustomers("")

            if(response.success) {
                let data = response.data
                setDataItems(data)
            } else {
                setOpenAlert(true);
                setDataAlert({
                    message: response.message,
                    type: 'error'
                })
            }
        } else {
            const response = await CustomerServices.GetAllCustomers(value)

            if(response.success) {
                let data = response.data
                setDataItems(data)
            } else {
                setOpenAlert(true);
                setDataAlert({
                    message: response.message,
                    type: 'error'
                })
            }
        }
    }


    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <NavBar />
            <Container style={theme.containerButtonNew}>
                <Link
                    to="/cliente/nuevo"
                    style={{ textDecoration: "none", color: "inherit" }}
                >
                    <Button variant="contained" style={theme.buttonNew} startIcon={<AddCircleOutlineIcon />}>Nuevo</Button>
                </Link>
            </Container>
            <Container style={{ textAlign: "right", paddingBottom: 15, }}>
                <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
                    <InputLabel htmlFor="searchInput" color="independece">Búsqueda</InputLabel>
                    <Input
                        id="searchInput"
                        value={searchQuery}
                        onChange={( (e) => handleSearch(e.target.value) )}
                        color="independece"
                        endAdornment={
                            <InputAdornment position="end"> <SearchIcon  /> </InputAdornment>
                        }
                    />
                </FormControl>
            </Container>
            <Container>

                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableRow style={theme.tableHeader}>
                                <TableCell style={theme.tableHeader}>ID Cliente</TableCell>
                                <TableCell align="left" style={theme.tableHeader}>Nombre</TableCell>
                                <TableCell align="left" style={theme.tableHeader}>Apellidos</TableCell>
                                <TableCell align="left" style={theme.tableHeader}>Correo</TableCell>
                                <TableCell align="left" style={theme.tableHeader}>Teléfono</TableCell>
                                <TableCell align="left" style={theme.tableHeader}>Acciones</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataItems.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {data.customerId}
                                    </TableCell>
                                    <TableCell>
                                        {data.name}
                                    </TableCell>
                                    <TableCell>
                                        {data.lastName}
                                    </TableCell>
                                    <TableCell>
                                        {data.email}
                                    </TableCell>
                                    <TableCell>
                                        {data.mobile}
                                    </TableCell>
                                    <TableCell>
                                        <Stack direction="row" spacing={2} >
                                            <IconButton
                                                onClick={() => openDetails(data.customerId)}
                                            >
                                                <img
                                                    alt="View Icon"
                                                    src={ViewIconRoute}
                                                    style={theme.avatarActions}
                                                />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => {
                                                    setDataConfirmation({
                                                        message: (data.customerId + ' y nombre ' + data.name + ' ' + data.lastName),
                                                        id: data.customerId
                                                    })

                                                    setOpenConfirmation(true)
                                                }}
                                            >
                                                <img
                                                    alt="Delete Icon"
                                                    src={DeleteIconRoute}
                                                    style={theme.avatarActions}
                                                />
                                            </IconButton>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    rowsPerPageOptions={[10, 15, 20]}
                    component="div"
                    labelRowsPerPage="Registros por página"
                    count={dataItems.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(+e.target.value)
                        setPage(0);
                    }}
                />

                <Alerts changeState={changeStateAlert} open={openAlert} data={dataAlert} />
                <LoaderScreen open={openLoader} text={textLoader} />
            </Container>
            <Dialog
                open={openConfirmation}
                onClose={changeStateConfirmation}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Eliminar cliente
                </DialogTitle>
                <DialogContent>
                    ¿Esta seguro de eliminar la información correspondiente al cliente con ID {dataConfirmation.message} <strong>(Cotizaciones y Contratos)</strong>? <p><strong>ESTA ACCIÓN ES IRREVERSIBLE.</strong></p>
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={changeStateConfirmation}>Cancelar</Button>
                    <Button onClick={deleteUser}>Aceptar</Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}

export default Clients;